"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseReserve = exports.isReserve = exports.RESERVE_SIZE = exports.ReserveLayout = exports.ReserveConfigLayout = exports.ReserveFeesLayout = exports.ReserveCollateralLayout = exports.ReserveLiquidityLayout = void 0;
const buffer_layout_1 = require("buffer-layout");
const util_1 = require("../util");
const lastUpdate_1 = require("./lastUpdate");
/** @internal */
exports.ReserveLiquidityLayout = (0, buffer_layout_1.struct)([
    (0, util_1.publicKey)('mintPubkey'),
    (0, buffer_layout_1.u8)('mintDecimals'),
    (0, util_1.publicKey)('supplyPubkey'),
    (0, util_1.publicKey)('feeReceiver'),
    (0, util_1.publicKey)('oraclePubkey'),
    (0, util_1.u64)('availableAmount'),
    (0, util_1.decimal)('borrowedAmountWads'),
    (0, util_1.decimal)('cumulativeBorrowRateWads'),
    (0, util_1.decimal)('marketPrice'),
], 'liquidity');
/** @internal */
exports.ReserveCollateralLayout = (0, buffer_layout_1.struct)([(0, util_1.publicKey)('mintPubkey'), (0, util_1.u64)('mintTotalSupply'), (0, util_1.publicKey)('supplyPubkey')], 'collateral');
/** @internal */
exports.ReserveFeesLayout = (0, buffer_layout_1.struct)([(0, util_1.u64)('borrowFeeWad'), (0, util_1.u64)('flashLoanFeeWad'), (0, buffer_layout_1.u8)('hostFeePercentage')], 'fees');
/** @internal */
exports.ReserveConfigLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_1.u8)('optimalUtilizationRate'),
    (0, buffer_layout_1.u8)('loanToValueRatio'),
    (0, buffer_layout_1.u8)('liquidationBonus'),
    (0, buffer_layout_1.u8)('liquidationThreshold'),
    (0, buffer_layout_1.u8)('minBorrowRate'),
    (0, buffer_layout_1.u8)('optimalBorrowRate'),
    (0, buffer_layout_1.u8)('maxBorrowRate'),
    exports.ReserveFeesLayout,
    (0, util_1.u64)('depositLimit'),
    (0, util_1.u64)('borrowLimit'),
    (0, util_1.publicKey)('feeReceiver'),
], 'config');
/** @internal */
exports.ReserveLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_1.u8)('version'),
    lastUpdate_1.LastUpdateLayout,
    (0, util_1.publicKey)('lendingMarket'),
    exports.ReserveLiquidityLayout,
    exports.ReserveCollateralLayout,
    exports.ReserveConfigLayout,
    (0, buffer_layout_1.blob)(248, 'padding'),
]);
exports.RESERVE_SIZE = exports.ReserveLayout.span;
const isReserve = (info) => {
    return info.data.length === exports.RESERVE_SIZE;
};
exports.isReserve = isReserve;
const parseReserve = (pubkey, info) => {
    if (!(0, exports.isReserve)(info))
        return;
    const buffer = Buffer.from(info.data);
    const reserve = exports.ReserveLayout.decode(buffer);
    if (!reserve.version)
        return;
    return {
        pubkey,
        info,
        data: reserve,
    };
};
exports.parseReserve = parseReserve;
